<template>
  <div style="text-align: left;">
    <el-input
        ref="input-item"
        v-model="inputValue"
        v-if="editing || !useButton"
        placeholder="请输入"
        @keyup.enter.native="submitInputValue"
        @blur="submitInputValue"
    ></el-input>
    <div v-if="!editing && useButton">
      <el-button
          @click="setEditing()"
          size="mini"
          icon="el-icon-plus"
      >{{ text || '新增' }}
      </el-button>
    </div>
    <div style="margin-top: 15px; min-height: 15px">
      <span v-if="!inputArray.length">-</span>
      <el-tag
          v-for="(s, idx) in inputArray"
          :key="s"
          closable
          size="small"
          @close="removeInputValue(idx)"
      >{{ s }}
      </el-tag>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [String, Number],
    text: String,
    useButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: '',
      editing: false,
      inputArray: []
    }
  },
  watch: {
    value(n, o) {
      if (n && n !== o) {
        this.inputArray = n.split(',').sort((s1, s2) => s1.length - s2.length)
        return
      }
      this.inputArray = []
    }
  },
  methods: {
    setEditing(val) {
      this.editing = true
      this.inputValue = val || ''
      this.$nextTick(() => {
        this.$refs['input-item'].$refs['input'].focus()
      })
    },
    setUnEditing() {
      this.editing = false
      this.inputValue = ''
    },
    submitInputValue() {
      if (!this.inputValue) {
        this.setUnEditing()
        return
      }
      this.inputArray.push(this.inputValue)
      this.inputValue = ''
      this.editing = false
      this.$emit('input', this.inputArray.join(','))
    },
    removeInputValue(idx) {
      if (idx > -1) {
        this.inputArray.splice(idx, 1)
        this.$emit('input', this.inputArray.join(','))
      }
    }
  }
}
</script>
<style scoped>
.el-tag {
  margin-right: 15px;
}
</style>
